export var TypeActionTraderEventInfo;
(function (TypeActionTraderEventInfo) {
    TypeActionTraderEventInfo["Request"] = "TraderEvent > Request";
    TypeActionTraderEventInfo["Received"] = "TraderEvent > Received";
    TypeActionTraderEventInfo["BuyPackage"] = "TraderEvent > BuyPackage";
    TypeActionTraderEventInfo["RequestBuyPackage"] = "TraderEvent > RequestBuyPackage";
})(TypeActionTraderEventInfo || (TypeActionTraderEventInfo = {}));
export var actionTraderEventReceived = function (trader) { return ({
    trader: trader,
    type: TypeActionTraderEventInfo.Received,
}); };
export var actionTraderEventBuyPackage = function (packageId) { return ({
    packageId: packageId,
    type: TypeActionTraderEventInfo.BuyPackage,
}); };
export var actionTraderEventRequestBuyPackage = function (packageId) { return ({
    packageId: packageId,
    type: TypeActionTraderEventInfo.RequestBuyPackage,
}); };
export var actionTraderEventRequest = function () { return ({
    type: TypeActionTraderEventInfo.Request,
}); };



//////////////////
// WEBPACK FOOTER
// ./src/features/trader-event/actionTraderEventInfo.ts
// module id = 358
// module chunks = 3